import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import { completedOrDelayed, countVisit, visitCount, weeksSince } from '@polleverywhere/pe-nps-feedback/lib/utils'
import listenToSelector from '../../util/listen_to_selector'
import { createSelector } from '@reduxjs/toolkit'
import themes from '../../components/theme_picker/themes'

// For now we will only trigger when a user navigates between
// L1 nav items. If we want to trigger this on other events like a view change
// then add the following to the selector:
//
//  (state) => state[activitySlice.name].view,
//  (appPage, activitiesPage) => {
//    return appPage === 'activities' ? activitiesPage : appPage
//  }
const selectPageForFeedback = createSelector(
  (state) => state[appSlice.name].page,
  (page) => page
)

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)
  // don't show feedback unless in light mode
  const theme = themes.auto.statusBar()
  if (theme !== 'light') return

  dispatcher.listenToOnce(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenToOnce(state, 'session:start', (user) => {
      const unsubscribe = listenToSelector((state) => selectPageForFeedback(state), (page) => {
        if (page === 'feedback') return
        if (page === 'login') return
        if (state.appStates.slideware.get('page') === 'background') return

        if (shouldShow({ user: store.getState()[profileSlice.name].user })) {
          unsubscribe()
          store.dispatch(appSlice.pageUpdated('feedback'))
        }
      })
    })
  })
}

function shouldShow ({ user } = {}) {
  if (!user) return false
  if (completedOrDelayed()) return false
  if (weeksSince(user.created_at) >= 2 && visitCount() >= 3) return true

  countVisit()
  return false
}
